import React from "react";
import DueBillsGrid from "./Grid";
import WithDrawer from "./../../../Dispatch/Common/Drawer/WithDrawer";
import Footer from "../../components/Footer";
import CancelButton from "../../components/Buttons/CancelButton";
import { Button } from "@material-ui/core";
class TrapBill extends React.Component {
  constructor(props) {
    super(props);
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.selectPros();
  };

  selectPros = () => {
    this.gridApi.forEachNode((node) => {
      if (this.props.selectedPros.includes(node.data.proId)) {
        node.setSelected(true);
      }
    });
  };

  handleSubmit = () => {
    this.props.onSubmit(this.gridApi.getSelectedRows());
  };

  render() {
    return (
      <>
        <DueBillsGrid
          rowData={this.props.data}
          onGridReady={this.onGridReady}
          getRowNodeId={(data) => data.proId}
          glEventHub={this.props.glEventHub}
        />
        <Footer>
          <CancelButton onClick={this.props.onCancel} />
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleSubmit}
          >
            Done
          </Button>
        </Footer>
      </>
    );
  }
}

export default WithDrawer(TrapBill);
